import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import dimensions from './theme/dimentions';
import palette from './theme/palette';
import { useLocalization } from './localization';
import { useEffect } from 'react';

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [rtlPlugin],
});
var theme = createTheme({
  typography: {
    fontFamily: "IBM Plex Sans Thai Looped"
  },
  dimensions,
  palette,
  
  // direction: 'ltr',
});

export default function RTL(props) {
  const { direction } = useLocalization();
  
  useEffect(() => {
    theme.direction = direction;
    
    if (direction === 'rtl') {
      theme = createTheme({
        
        typography: {
          fontFamily: "Homa"
        },
        dimensions,
        palette,
        
        direction: 'rtl',
      });
      
    }
    document.body.dir = direction;
  }, [direction])

  return (

    direction == 'rtl' ? < CacheProvider value={cacheRtl} >
      < ThemeProvider theme={theme} >
        {props.children}
      </ThemeProvider >
    </CacheProvider > :

      < ThemeProvider theme={theme} >
        {props.children}
      </ThemeProvider >

  );
}